import React, { useState ,useEffect,useRef } from "react";
import "./NavBar.css";

import ListItem from "../ListItem";
import classNames from "classnames";
import logo from './../../images/logo.png'
import DropDownUser from "../DropDownUser";

export default function NavBar() {  
  const [isChecked, setIsChecked] = useState(false);
  const ref = useRef()
  const token = localStorage.getItem('token')

  const navLinks = [
    { key:1 , name: "Home", link: "/home ", classname : "w-full" },
    { key:2 , name: "Login", link: '/Login' , classname : "w-full text-red" },
    { key:3 , name: "Sign up", link: '/register' , classname : "w-full" },
    { key:4 , name: "Contact", link: '/Contact' , classname : "w-full" },
 ]
 useEffect(() => {
  const handleResize = () => {
    if (window.innerWidth >= 640) {
      
      setIsChecked(false);
    }
  };
  window.addEventListener('resize', handleResize);
  return () => {
    window.removeEventListener('resize', handleResize);
  };
}, []);

useEffect(() => {
  const checkIfClickedOutside = e => {
    if (isChecked && ref.current && !ref.current.contains(e.target)) {
      setIsChecked(false)
      console.log("hello")
    }
  }
  document.addEventListener("mousedown", checkIfClickedOutside)
  return () => {
    document.removeEventListener("mousedown", checkIfClickedOutside)
  }
}, [isChecked])
  return (
    <div className="container w-11/12 mx-auto">
      <nav className="flex flex-row sm:flex-row mt-5 sm:mt-10 items-center border-b-4 pb-3 border-r-0 sm:border-none justify-between">
        <div className="logo w-full lg:flex gap-3 items-center  " onClick={() => window.scrollTo({top: 0, left: 0, behavior: 'smooth'})}>
          <img src={logo} alt="this is logo" className="w-10   sm:mb-0 inline" />
          <span className="text-2xl font-medium hidden lg:inline-block">Social Media</span>
        </div>
          <button
          ref={ref}
            className="sm:hidden w-8"
            onClick={() => {
              setIsChecked((prev) => !prev);
            }}
          >
            <i className="fas fa-bars text-xl"></i>
          </button>
        <ul className={classNames( "text-center items-center flex-col justify-end sm:flex-row bg-[#458bb6]  sm:bg-transparent w-[100vw] mt-5 sm:mt-0 md:w-[71vw] lg:w-[52vw]   sm:flex sm:left-0 top-[10%] hidden "
          )}>
              {navLinks.map((item) => <ListItem  key = {item.key} name={item.name} link={item.link} classname={item.classname} />)}
        </ul>
        
      </nav>
          <DropDownUser list={navLinks} classParentList="flex !gap-3" classList="w-11/12 text-left" navBar ={true} classIcon="hidden" classname={classNames("sm:hidden bgDropDown bg-white",
               {
                   'disapper':!isChecked,
                   'show !ml-0':isChecked,
               })} />
    </div>
  );
}
